export default "__VITE_ASSET__LUwa$lK0__"